import queryString from 'query-string'
import humps from 'humps'

import { PAGE_SIZE } from '../lib/constants'
import apiClient from './api-client'

function list(practiceId, cycleId, page, filters, perPage) {
  // TODO: Enable when the API is ready
  if (practiceId) {
    throw new Error('Not implemented')
  } else {
    const options = { withHeaders: true }
    const pageFilter = page === 'all' ? { all: true } : { page }
    const query = humps.decamelizeKeys({
      ...filters,
      ...pageFilter,
      cycleId,
      perPage: perPage || PAGE_SIZE,
    })

    return apiClient.get(
      queryString.stringifyUrl({
        url: `/practices/${practiceId}/office-checks`,
        query,
      }),
      options,
    )
  }
}

function get(id) {
  return apiClient.get(`/v2/remote-checks/${id}`)
}

function destroy(id) {
  return apiClient.destroy(`v2/remote-checks/${id}`)
}

function getReportForm(id) {
  return apiClient.get(`/v2/remote-checks/${id}/report/form`)
}

function createBiobridgeReport(id, reportFormData) {
  return apiClient.post(`/v2/remote-checks/${id}/report/form`, reportFormData)
}

function updateBiobridgeReport(id, reportFormData) {
  return apiClient.patch(`/v2/remote-checks/${id}/report/form`, reportFormData)
}

function archiveReport(id) {
  return apiClient.patch(`/v2/remote-checks/${id}/archive`)
}

function deactivateIcm(id) {
  return apiClient.destroy(`v2/remote-checks/${id}/icm-activation`)
}

// DEPRECATED: previous implementation no longer used
function updateTransmission(id, data) {
  return apiClient.patch(`/v2/remote-checks/${id}`, { remoteCheck: data })
}

// Add a transmission to a remote check (optionally set as main)
function addTransmission(remoteCheckId, transmissionId, main = false) {
  return apiClient.patch(`/v2/remote-checks/${remoteCheckId}/transmissions`, {
    transmission_id: transmissionId,
    main,
  })
}

// Remove a transmission from a remote check
function removeTransmission(remoteCheckId, transmissionId) {
  return apiClient.destroy(
    `/v2/remote-checks/${remoteCheckId}/transmissions/${transmissionId}`,
  )
}

export default {
  list,
  get,
  destroy,
  getReportForm,
  createBiobridgeReport,
  updateBiobridgeReport,
  archiveReport,
  deactivateIcm,
  updateTransmission, // kept for backward compatibility
  addTransmission,
  removeTransmission,
}
